import WebViewer from '@pdftron/webviewer';
import { useEffect, useRef } from 'react';
import { xfdfString } from './util';

export const PDFWebViewer = () => {
  const viewerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (viewerRef.current) {
      WebViewer(
        {
          path: '/webviewer2/lib',
          licenseKey: `demo:kyle.jones@dynabytetech.com:606780200200000000a60373c19277b97f8b6f3a87b30889adda7e6578`
          // initialDoc:'https://pdftron.s3.amazonaws.com/downloads/pl/form1.pdf'
          // initialDoc: '/BuilderLinq Contract 2025-04-01 copy (1).pdf'
          // initialDoc: '/BuilderLinq Contract.pdf'
        },
        viewerRef.current
      ).then(instance => {
        const { documentViewer, annotationManager } = instance.Core;

        document.getElementById('select').onchange = e => {
          instance.UI.loadDocument((e.target as HTMLSelectElement).value);
        };

        // document.getElementById('file-picker').onchange = e => {
        //   const input = e.target as HTMLInputElement;
        //   const file = input.files?.[0];
        //   if (file) {
        //     instance.UI.loadDocument(file);
        //   }
        // };

        // adds the the ability to edit pdf text
        instance.UI.enableFeatures([instance.UI.Feature.ContentEdit]);

        /** SECTION for loading annotations into the pdf for a pdf that doesn't have any
         *
         */
        documentViewer.addEventListener('documentLoaded', () => {
          const el = document.getElementById('load-annotations');
          if (el) {
            el.onclick = async e => {
              await annotationManager.importAnnotations(xfdfString);
            };
          }
        });
        /**
         * This auto exports the annotations
         */
        documentViewer.addEventListener('annotationsLoaded', () => {
          // widgets and links will remain in the document without changing so it isn't necessary to export them
          annotationManager
            .exportAnnotations({ links: true, widgets: true, fields: true })
            .then(xfdfString => {
              console.log(xfdfString);
            });
        });
      });
    }
  }, []);

  return <div ref={viewerRef} style={{ height: '100vh' }} />;
};
